import React, { Fragment } from 'react'
import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Spinner,
  Button,
  Text
} from '@chakra-ui/react'
import { Link } from 'react-router-dom';
import { MdOutlineChevronRight } from "react-icons/md";

import AllFillters from './Layout/AllFillters';


function AllVerification({ title, head, data, isLoading }) {

    data.sort((a,b) => {
        return new Date(b.placedDate) - new Date(a.placedDate)
    })

   console.log(data, 'klsdfjlsdfklsjdfjlwjkfe')
   
  return (
    <Fragment>
       <AllFillters
                title={title}
                data={data}
                create={'Cutomer Verification'}
            //     filters = {[{"Filter Verification":[{id: 'VERIFIED', title: 'Verified'}, {id: 'PENDING', title: 'Pending'}, {id: 'UNVERIFIED', title: 'Unverified'}
            // ]}]}
             />
      <Box maxW={'full'} my={4}>
                <TableContainer height={`${window.innerHeight - 244}px`} overflowY={'scroll'}>
                    <Table variant={'simple'} size={'xs'}>
                        <Thead bgColor={'gray.100'} position={'sticky'} top={'0px'} zIndex={'99'}>
                            <Tr bgColor={'#E2DFDF'}>
                                {head.map((h, i) => (
                                    <Th key={i} fontSize={'xs'} py={3} _first={{paddingLeft: '20px'}} color={'#25282B'}>{h}</Th>
                                ))}
                            </Tr>
                        </Thead>
                        <Tbody>
                        {(data.length > 0) ?
                         <>
                       
                            {data.map((d, i) => (
                                <Tr key={i} bgColor={'white'}>
                                    <Td fontSize={'sm'} py={3} pl={5}>{d?.OrderName.includes('#') ? d?.OrderName : 'pending'}</Td>
                                    <Td fontSize={'sm'} py={3} >{new Intl.DateTimeFormat('en-US', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                            hour: 'numeric',
                                            minute: 'numeric',
                                            hour12: true,
                                            timeZone: 'ASIA/KOLKATA'
                                          }).format(new Date(d.entryDate))}</Td>
                                    
                                    <Td fontSize={'sm'} py={3}>{d?.customerParty?.firstName + " " + d?.customerParty?.lastName}</Td>
                                    {/* <Td fontSize={'sm'} py={3}>{'----'}</Td> */}
                                    <Td fontSize={'sm'} py={3}>
                                        {((d?.orderStatusId === "ORDER_CREATED") || (d?.orderStatusId === "ORDER_PUBLISHED") || (d?.orderStatusId === "ORDER_DRAFT") ) ?  
                                         <Button size={'xs'} cursor={'default'} colorScheme={'telegram'}>
                                            Pending
                                        </Button>
                                        : (d?.orderStatusId === "AWAITING_VERIFICATION") ?
                                         <Button size={'xs'} cursor={'default'} colorScheme={'cyan'}>
                                            Awaiting 
                                        </Button>
                                        :
                                        d?.orderStatusId === "ORDER_CANCELED" ? 
                                        <Button size={'xs'} cursor={'default'} colorScheme={'red'}>
                                            Unverified
                                        </Button>
                
                                       :   
                                        <Button size={'xs'} cursor={'default'} colorScheme={'green'}>
                                            Verified
                                        </Button>
                                        }
                                    </Td>
                                    <Td fontSize={'sm'} py={3}>
                                        {((d?.orderStatusId === "ORDER_CREATED") || (d?.orderStatusId === "ORDER_PUBLISHED") || (d?.orderStatusId === "ORDER_DRAFT")) ?  
                                         <Button size={'xs'} cursor={'default'} colorScheme={'telegram'}>
                                            Pending
                                        </Button>
                                        : (d?.orderStatusId === "AWAITING_VERIFICATION") ?
                                         <Button size={'xs'} cursor={'default'} colorScheme={'cyan'}>
                                            Awaiting 
                                        </Button>
                                        :
                                        d?.orderStatusId === "ORDER_CANCELED" ? 
                                        <Button size={'xs'} cursor={'default'} colorScheme={'red'}>
                                            Unverified
                                        </Button>
                
                                       :   
                                        <Button size={'xs'} cursor={'default'} colorScheme={'green'}>
                                            Verified
                                        </Button>
                                        }
                                    </Td>
                                    <Td fontSize={'sm'}>
                                        <Flex>
                                            <Box bgColor={'gray.200'} rounded={'full'} my="auto" p={2} mx={2}>
                                                <Link to={`/verification/customer-verification-details/${d.id}`} > <MdOutlineChevronRight /> </Link>
                                            </Box>
                                        </Flex>
                                    </Td>
                                </Tr>
                            ))}
                            </>
                            :
                            <Tr>
                          <Td></Td>
                          <Td></Td>
                          <Td></Td>
                          <Td textAlign={'center'}>
                          {isLoading?.loading === true ?
                            <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor='gray.200'
                            color='blue.500'
                            size='xl'
                            mt={4}
                        
                          />
                          :
                          isLoading?.error === true ? <Text fontWeight={'semibold'} color={'red.500'}>Oops we are facing some temporary issue with your request</Text> : <Text  fontWeight={'semibold'} color={'green.500'}>NO ORDERS AVAILABLE</Text>
                          } 
                          </Td>
                          <Td></Td>
                          <Td></Td>
                          <Td></Td>
                         </Tr>
                        }
                        </Tbody>
                    </Table>
                </TableContainer>
            </Box>
    </Fragment>
  )
}

export default AllVerification